<template>
  <div
    v-if="loading"
    class="Squares gap-4 sm:px-4 Squares--LastOpened Squares--Placeholders"
  >
    <folder-grid-item-loading v-for="i in 10" :key="i" />
  </div>
  <aw-drop
    v-else
    :list="list"
    list-item-key="url"
    @drop-item="dropItem"
    drop-direction="x"
    class="Squares gap-4 lg:gap-6 sm:px-4"
    :drop-area-id="'folder-grid-' + bcFolderStore?.current?.id"
  >
    <template #default="{ item, index, isDropActive, dropAreaId }">
      <folder-grid-item
        :item="item"
        :rank="index"
        :class="{ Square__DropPlaceholder: item.placeholder }"
        :jiggle="isDropActive"
        :key="item.url"
        :draggable="!disableDraggable"
        :original-drop-area-id="dropAreaId"
      />
    </template>
    <template #footer>
      <folder-grid-item-upload-files v-if="showNew" class="col-start-1" />
      <folder-grid-item-new-document v-if="showNew" />
      <folder-grid-item-new-folder v-if="showNew" />
    </template>
  </aw-drop>
</template>

<script>
import { mapStores } from 'pinia'
import bcFolderStore from '@/frontapp/store/bcFolder'
import FolderList from '../../mixins/FolderList'

export default {
  mixins: [FolderList],
  props: {
    list: Array,
    loading: {
      type: Boolean,
      default: false
    },
    showNew: {
      type: Boolean,
      default: true
    },
  },
  computed: {
   ...mapStores(bcFolderStore),
    parentBcFolderId() {
      return this.bcFolderStore.current.id
    }
  }
}
</script>
